/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const addUser = /* GraphQL */ `
  mutation AddUser($addUserInput: AddUserInput!) {
    addUser(addUserInput: $addUserInput) {
      PK
      SK
      id
      userType
      email
      data
      status
      prefix
      firstName
      lastName
      school
      schoolCode
      avatar
      detail
      createdAt
      updatedAt
    }
  }
`;
export const addTeacher = /* GraphQL */ `
  mutation AddTeacher($addTeacherInput: AddTeacherInput!) {
    addTeacher(addTeacherInput: $addTeacherInput) {
      PK
      SK
      id
      code
      prefix
      firstName
      lastName
      email
      classes
      status
      school
      schoolCode
      avatar
      createdAt
      updatedAt
    }
  }
`;
export const addSchool = /* GraphQL */ `
  mutation AddSchool($addSchoolInput: AddSchoolInput!) {
    addSchool(addSchoolInput: $addSchoolInput) {
      PK
      SK
      id
      schoolCode
      name
      email
      address
      city
      state
      zip
      avatar
      data
      createdAt
      updatedAt
      status
    }
  }
`;
export const updateTeacher = /* GraphQL */ `
  mutation UpdateTeacher($updateTeacherInput: UpdateTeacherInput!) {
    updateTeacher(updateTeacherInput: $updateTeacherInput) {
      PK
      SK
      id
      code
      prefix
      firstName
      lastName
      email
      classes
      status
      school
      schoolCode
      avatar
      createdAt
      updatedAt
    }
  }
`;
export const deleteTeacher = /* GraphQL */ `
  mutation DeleteTeacher($deleteTeacherInput: DeleteTeacherInput!) {
    deleteTeacher(deleteTeacherInput: $deleteTeacherInput)
  }
`;
export const addStudent = /* GraphQL */ `
  mutation AddStudent($addStudentInput: AddStudentInput!) {
    addStudent(addStudentInput: $addStudentInput) {
      PK
      SK
      id
      code
      firstName
      lastName
      identityType
      identityImage
      identityCode
      classes
      school
      schoolCode
      level
      currentPath
      pathId
      nextPath
      lastResult
      paths
      avatar
      status
      createdAt
      updatedAt
    }
  }
`;
export const addStudentClassroom = /* GraphQL */ `
  mutation AddStudentClassroom(
    $addStudentClassroomInput: AddStudentClassroomInput!
  ) {
    addStudentClassroom(addStudentClassroomInput: $addStudentClassroomInput) {
      PK
      SK
      id
      code
      firstName
      lastName
      identityType
      identityImage
      identityCode
      classes
      school
      schoolCode
      level
      currentPath
      pathId
      nextPath
      lastResult
      paths
      avatar
      status
      createdAt
      updatedAt
    }
  }
`;
export const updateStudent = /* GraphQL */ `
  mutation UpdateStudent($updateStudentInput: UpdateStudentInput!) {
    updateStudent(updateStudentInput: $updateStudentInput) {
      PK
      SK
      id
      code
      firstName
      lastName
      identityType
      identityImage
      identityCode
      classes
      school
      schoolCode
      level
      currentPath
      pathId
      nextPath
      lastResult
      paths
      avatar
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteStudent = /* GraphQL */ `
  mutation DeleteStudent($deleteStudentInput: DeleteStudentInput!) {
    deleteStudent(deleteStudentInput: $deleteStudentInput)
  }
`;
export const addClassroom = /* GraphQL */ `
  mutation AddClassroom($addClassroomInput: AddClassroomInput!) {
    addClassroom(addClassroomInput: $addClassroomInput) {
      PK
      SK
      id
      name
      level
      clsCode
      code
      students
      school
      schoolCode
      status
      createdAt
      updatedAt
    }
  }
`;
export const addClassroomTeacher = /* GraphQL */ `
  mutation AddClassroomTeacher(
    $addClassroomTeacherInput: AddClassroomTeacherInput!
  ) {
    addClassroomTeacher(addClassroomTeacherInput: $addClassroomTeacherInput) {
      PK
      SK
      id
      name
      level
      clsCode
      code
      students
      school
      schoolCode
      status
      createdAt
      updatedAt
    }
  }
`;
export const addTeacherSchool = /* GraphQL */ `
  mutation AddTeacherSchool($addTeacherSchoolInput: AddTeacherSchoolInput!) {
    addTeacherSchool(addTeacherSchoolInput: $addTeacherSchoolInput) {
      PK
      SK
      id
      code
      prefix
      firstName
      lastName
      email
      classes
      status
      school
      schoolCode
      avatar
      createdAt
      updatedAt
    }
  }
`;
export const updateClassroom = /* GraphQL */ `
  mutation UpdateClassroom($updateClassroomInput: UpdateClassroomInput!) {
    updateClassroom(updateClassroomInput: $updateClassroomInput) {
      PK
      SK
      id
      name
      level
      clsCode
      code
      students
      school
      schoolCode
      status
      createdAt
      updatedAt
    }
  }
`;
export const deleteClassroom = /* GraphQL */ `
  mutation DeleteClassroom($deleteClassroomInput: DeleteClassroomInput!) {
    deleteClassroom(deleteClassroomInput: $deleteClassroomInput)
  }
`;
export const addContent = /* GraphQL */ `
  mutation AddContent($addContentInput: AddContentInput!) {
    addContent(addContentInput: $addContentInput) {
      PK
      SK
      id
      method
      category
      name
      title
      contentType
      description
      level
      owner
      createdAt
      updatedAt
      partsDescription
      structure {
        partsCount
        partElements
        defaultPresentation
      }
      parts {
        id
        name
      }
      benchmarkId
      benchmarkVersion
      status
    }
  }
`;
export const addPart = /* GraphQL */ `
  mutation AddPart($addPartContentInput: AddPartContentInput!) {
    addPart(addPartContentInput: $addPartContentInput) {
      PK
      SK
      id
      name
      level
      partNumber
      parentId
      parentName
      description
      method
      details {
        index
        elements
        elementType
        elementLength
        wordCount
      }
      data
      createdAt
      updatedAt
      status
    }
  }
`;
export const addEPath = /* GraphQL */ `
  mutation AddEPath($addEPathInput: AddEPathInput!) {
    addEPath(addEPathInput: $addEPathInput) {
      PK
      SK
      id
      name
      title
      pathType
      level
      description
      config
      elementCount
      elements {
        id
        name
      }
      status
      createdAt
      updatedAt
    }
  }
`;
export const addAssessment = /* GraphQL */ `
  mutation AddAssessment($addAssessmentInput: AddAssessmentInput!) {
    addAssessment(addAssessmentInput: $addAssessmentInput) {
      PK
      SK
      id
      pathName
      pathId
      pathTitle
      studentId
      teacherCode
      schoolCode
      asmtStatus
      elementCount
      elements {
        id
        name
        status
        scoreId
        contentId
        timelimit
        totalDuration
        updatedAt
      }
      createdAt
      updatedAt
      status
    }
  }
`;
export const addScore = /* GraphQL */ `
  mutation AddScore($addScoreInput: AddScoreInput!) {
    addScore(addScoreInput: $addScoreInput) {
      id
      scoreType
      assessmentId
      componentId
      studentId
      totalItems
      correct
      errors
      data
      duration
      timeLimitOffset
      contentType
      benchmarkId
      benchmarkVersion
      status
      updatedAt
    }
  }
`;
export const addGeneratedContent = /* GraphQL */ `
  mutation AddGeneratedContent(
    $addGeneratedContentInput: AddGeneratedContentInput!
  ) {
    addGeneratedContent(addGeneratedContentInput: $addGeneratedContentInput) {
      PK
      SK
      id
      method
      category
      name
      title
      contentType
      description
      level
      owner
      createdAt
      updatedAt
      partsDescription
      structure {
        partsCount
        partElements
        defaultPresentation
      }
      parts {
        id
        name
      }
      benchmarkId
      benchmarkVersion
      status
    }
  }
`;
export const updateAssessment = /* GraphQL */ `
  mutation UpdateAssessment($updateAssessmentInput: UpdateAssessmentInput!) {
    updateAssessment(updateAssessmentInput: $updateAssessmentInput) {
      PK
      SK
      id
      pathName
      pathId
      pathTitle
      studentId
      teacherCode
      schoolCode
      asmtStatus
      elementCount
      elements {
        id
        name
        status
        scoreId
        contentId
        timelimit
        totalDuration
        updatedAt
      }
      createdAt
      updatedAt
      status
    }
  }
`;
export const updateScore = /* GraphQL */ `
  mutation UpdateScore($updateScoreInput: UpdateScoreInput!) {
    updateScore(updateScoreInput: $updateScoreInput) {
      id
      scoreType
      assessmentId
      componentId
      studentId
      totalItems
      correct
      errors
      data
      duration
      timeLimitOffset
      contentType
      benchmarkId
      benchmarkVersion
      status
      updatedAt
    }
  }
`;
export const updateAssessmentPart = /* GraphQL */ `
  mutation UpdateAssessmentPart(
    $updateAssessmentPartInput: UpdateAssessmentPartInput!
  ) {
    updateAssessmentPart(updateAssessmentPartInput: $updateAssessmentPartInput)
  }
`;
export const addAssessmentPart = /* GraphQL */ `
  mutation AddAssessmentPart($addAssessmentPartInput: AddAssessmentPartInput!) {
    addAssessmentPart(addAssessmentPartInput: $addAssessmentPartInput) {
      PK
      SK
      id
      assessmentId
      assessmentContentId
      audioPath
      bucket
      enabled
      testErrors
      level
      metricsJson {
        diffs_processed {
          difftype
          diffstring
        }
        insertions
        substitutions
        deletions
        processed_transcript
        editops {
          editType
          editsrc
          editdst
        }
        phonetic_error_word_idxs
        text_error_idxs
        nr_words
        nr_word_errors
        diffs {
          difftype
          diffstring
        }
        char2word
        wer
      }
      nrWords
      nrWordsErrors
      duration
      timeLimitOffset
      phoneticGndTruth
      phonetics
      prediction
      contentText
      scriptText
      phonemeText
      createdAt
      updatedAt
      status
    }
  }
`;
export const requestContent = /* GraphQL */ `
  mutation RequestContent($requestContentInput: RequestContentInput!) {
    requestContent(requestContentInput: $requestContentInput)
  }
`;
